"use strict";
/**
 * Mercedes-Benz Brand Palette Colors
 *
 * This palette contains colors for Mercedes-Benz
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mercedesColor = void 0;
var mercedesColor;
(function (mercedesColor) {
    // Main
    mercedesColor["black"] = "#000000";
    mercedesColor["highlight"] = "#00ADEF";
    mercedesColor["moon"] = "#F4F4F4";
    mercedesColor["white"] = "#FFFFFF";
    //Secondary
    mercedesColor["highlightDark"] = "#4A90E2";
    mercedesColor["highlightLight"] = "#57CDF5";
    mercedesColor["silver"] = "#BFBFBF";
    mercedesColor["gunmetal"] = "#666666";
    mercedesColor["mineshaft"] = "#262626";
    //State
    mercedesColor["error"] = "#E1292B";
    mercedesColor["valid"] = "#008A00";
    //Gradients
    mercedesColor["backgroundGradientStart"] = "#000000";
    mercedesColor["backgroundGradientEnd"] = "#2E2E2E";
    mercedesColor["buttonGradientStart"] = "#737373";
    mercedesColor["buttonGradientEnd"] = "#5A5A5A";
    mercedesColor["buttonLightGradientStart"] = "#F8F8F8";
    mercedesColor["buttonLightGradientEnd"] = "#DEDEDE";
    mercedesColor["buttonBlueGradientStart"] = "#00ADEF";
    mercedesColor["buttonBlueGradientEnd"] = "#0887BE";
})(mercedesColor = exports.mercedesColor || (exports.mercedesColor = {}));
exports.default = {
    mercedesColor: mercedesColor,
};
//# sourceMappingURL=mercedes.js.map